<template>
	<div class="display-flex flex-column width-100">
		<PlacementMenuItemRouterLink v-on="$listeners" v-bind="getItemProps(everythingItem)" />
		<div :key="i" v-for="(section, i) in placementsBySection">
			<component v-if="section.customSection" :is="section.customSection" v-bind="section.props" v-on="$listeners" />
			<!-- This comp above, is a custom 'standalone' section, very different from the others -->
			<template v-else-if="!section.hide">
				<div class="section-header-container display-flex flex-row flex-align-center mt-4 mb-1 flex-justify-space-between pa-1">
					<div class="section-title">{{ section.title }}</div>
					<component v-if="section.suffixComponent" :is="section.suffixComponent" />
				</div>
				<AppLoader color="#101840" v-if="section.isLoading" />
				<template v-else>
					<PlacementMenuItemRouterLink
						class="mb-1"
						v-on="$listeners"
						:key="item.id || i"
						v-bind="getItemProps(item)"
						v-for="(item, i) in section.items"
					/>
				</template>
			</template>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';

import AddOnsSelectFavoriteApps from './AddOnsSelectFavoriteApps.vue';
import { FeatureType } from '@/components/CreationWizard/Steps/ChooseProjectAndFeatureType/FeatureTypeSelector/feature-type-selector.const';
import PlacementLessAddOnsMenu from '@/components/ProjectMenu/PlacementLessAddOnsMenu.vue';
import PlacementMenuItemRouterLink from '@/components/ProjectMenu/PlacementMenuItemRouterLink.vue';
import { PLACEMENT_MODE_EVERYTHING_NAME } from '@/router/router.const.js';
import { getService, getServiceBySlug } from '@/store/modules/apps/getters';
import { userFavoriteApps, isLoadingUserData } from '@/store/modules/auth/getters';
import { getAllAccountConnections } from '@/store/modules/credentials/getters';
import { isAutomationEnabled } from '@/store/modules/featureFlags/getters';
import { useAppsWorkspaces } from '@/store/modules/workflows/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { URL_PLACEMENT_ID, COMMAND_BAR_PLACEMENT_ID } from '@/utils/workflow-tool-service.const';
import CreateAndManageService from '@/views/AppLayout/ManageAndCreate/create-and-manage-service.js';
export default {
	name: 'PlacementTabMenuContent',
	components: {
		PlacementLessAddOnsMenu,
		PlacementMenuItemRouterLink,
	},
	props: {},
	computed: {
		...mapGettersShorthand({
			getService,
			getServiceBySlug,
			userFavoriteApps,
			useAppsWorkspaces,
			isLoadingUserData,
			isAutomationEnabled,
			getAllAccountConnections,
		}),
		allAccountConnections() {
			return Object.values(this.getAllAccountConnections);
		},
		placementsBySection() {
			return [
				{
					title: 'Add-ons in apps',
					isLoading: this.isLoadingAddOnItems,
					items: this.addOnsItemsWithPlacement,
					suffixComponent: AddOnsSelectFavoriteApps,
				},
				{
					isLoading: this.isLoadingAddOnItems,
					customSection: PlacementLessAddOnsMenu,
					props: { items: this.placementLessAddOns, class: 'mt-1' },
				},
				{ title: 'Tools', items: this.toolsItems },
				{ title: 'Internal notifications', items: this.internalNotificationItems },
				// { title: 'Automation', items: this.automationItems, hide: !this.isAutomationEnabled },
				// { title: 'Portals', hide: true },
				// { title: 'Customer notifications', hide: true },
			];
		},
		isLoadingAddOnItems() {
			if (
				this.userFavoriteApps.length > 0 &&
				this.useAppsWorkspaces?.length > 0 &&
				Object.keys(this.allAccountConnections || {}).length > 0
			) {
				// If we have all the data we need, we can stop showing the loader
				return false;
			} else {
				return this.isLoadingUserData;
			}
		},
		addOnsItems() {
			return CreateAndManageService.getPlacementAddOnsItems(
				this.useAppsWorkspaces,
				this.userFavoriteApps,
				this.allAccountConnections,
				this.getService
			);
		},
		addOnsItemsWithPlacement() {
			return this.addOnsItems.filter((item) => CreateAndManageService.doesServiceHaveContext(this.getServiceBySlug(item.slug)));
		},
		placementLessAddOns() {
			return this.addOnsItems.filter((item) => !CreateAndManageService.doesServiceHaveContext(this.getServiceBySlug(item.slug)));
		},
		toolsItems() {
			return [
				{ title: 'Command bar', slug: COMMAND_BAR_PLACEMENT_ID },
				{ title: 'URL (with parameters)', slug: URL_PLACEMENT_ID },
			];
		},
		internalNotificationItems() {
			return [{ title: 'Notifications', slug: FeatureType.InternalNotification }];
		},
		automationItems() {
			return [{ title: 'All', slug: FeatureType.Automation }];
		},
		everythingItem() {
			return { title: 'Everything', navigateTo: { name: PLACEMENT_MODE_EVERYTHING_NAME } };
		},
	},
	methods: {
		...mapActions(['getUserCalculatedFavoriteApps']),
		getItemProps(item) {
			return CreateAndManageService.getItemProps(item);
		},
	},
	created() {
		this.getUserCalculatedFavoriteApps();
	},
};
</script>

<style scoped lang="scss">
.section-title {
	font-size: 11px;
	color: #8f95ab;
	letter-spacing: 0px;
}
.section-header-container {
	&:hover {
		background: #f4f5f66c;
	}
}
</style>
